export const personalInfoData = {
  firstName: 'Luke',
  lastName: 'Skywalker',
  userName: 'LukeSkywalker212',
  birthDate: '2004-06-03',
  country: 'United States',
  state: 'Pennsylvania',
  city: 'Essington',
  street: '500 Powhattan Ave',
  zip: '19029',
  phoneNumber: '(+880)1795448106',
  primaryEmail: 'something@email.com',
  secondaryEmail: 'something.alternate@email.com',
};
